export function getDateString(date: Date): string {
  return `${date.getFullYear().toString().padStart(2, '0')}${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`;
}

export function getDateTimeString(date: Date): string {
  return `${date.getFullYear().toString().padStart(2, '0')}${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}-${date
    .getHours()
    .toString()
    .padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;
}

export function getStartOfCurrentMonth(): Date {
  return new Date(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0
    )
  );
}

export function getEndOfToday(): Date {
  return new Date(new Date().setHours(23, 59, 59, 999));
}
